module.exports = __webpack_public_path__ + "static/media/icon-solutions-04.743d5eaa.svg";